var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { List, ListItem, Link, Tooltip } from '@material-ui/core';
export var TagCloud = function (_a) {
    var tags = _a.tags, onLinkClick = _a.onLinkClick, LinkComponent = _a.LinkComponent;
    return (React.createElement(List, { className: "faq-tag-cloud" }, tags.map(function (tag) {
        var props = {
            to: tag.link,
            onClick: onLinkClick ? function () { return onLinkClick(tag.link, {}); } : undefined,
            component: LinkComponent,
        };
        return (React.createElement(ListItem, { key: tag.link, className: "faq-tag-cloud__item", component: "li" },
            React.createElement(Tooltip, { title: tag.title },
                React.createElement(Link, __assign({ color: "textSecondary", underline: "none", className: "faq-tag-cloud__item__link" }, props), tag.title))));
    })));
};
//# sourceMappingURL=TagCloud.js.map